module.exports = __webpack_public_path__ + "static/img/jpg.645c16cd.png";